
import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import FoodGallery from '../components/FoodGallery';
import { Helmet } from 'react-helmet-async';
import FloatingWhatsApp from '../components/FloatingWhatsApp';

const Work = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Our Work | Grow99X</title>
      </Helmet>
      <Navbar />
      <div className="pt-24 pb-12 bg-grow99x-lightBg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Our Work</h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              A collection of our best food photography and social media content
            </p>
            <div className="h-1 w-20 bg-grow99x-orange mx-auto mt-4"></div>
          </div>
        </div>
      </div>
      <FoodGallery />
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};

export default Work;
